import React, { useEffect } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import FileUploadSingle from "../../../form/FileUploadSingle";
import DatePicker from "../../../form/DatePicker";
import { blogAddEdit } from "../../../../services/BlogService";

const validation = {
  title: { required: true, message: "Blog title is required" },
  publishDate: { required: true, message: "publish date is required" },
};

const ManageBlog = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({ ...data, image: data?.image?.url });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await blogAddEdit({
        ...val,
        type: "blog",
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-12">
          <Input
            label="Title"
            inputPlaceholder={"Enter"}
            inputName="title"
            value={values?.title || ""}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        {/* <div className="relative col-span-4">
          <Select
            label={"Category"}
            placeholder="Select category"
            selectedValue={values?.categoryId}
            dropdownData={
              [
                // { name: "Active", value: 1 },
                // { name: "InActive", value: 2 },
              ]
            }
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "categoryId", value: val },
              });
            }}
          />
        </div> */}
        <div className="relative col-span-12">
          <Editor
            label="Blog Content"
            placeholder="Content"
            value={values?.description}
            onChange={(val) =>
              handleChange({ target: { name: "description", value: val } })
            }
            {...formValidate(errors, "description")}
          />
        </div>
        <div className="relative col-span-6">
          <FileUploadSingle
            size="small"
            label={"Upload Cover Image"}
            value={values?.image}
            onChange={(file) =>
              handleChange({ target: { name: "image", value: file } })
            }
            {...formValidate(errors, "image")}
          />
        </div>
        <div className="relative col-span-3">
          <Select
            label={"Featured (yes/no)"}
            placeholder="Select featured"
            selectedValue={values?.featured}
            dropdownData={[
              { name: "Yes", value: true },
              { name: "No", value: false },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "featured", value: val },
              });
            }}
          />
        </div>
        <div className="relative col-span-3">
          <DatePicker
            label={"Published Date"}
            value={{
              startDate: values?.publishDate,
              endDate: values?.publishDate,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "publishDate" },
              });
            }}
            {...formValidate(errors, "publishDate")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageBlog;
